import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-hot-toast';
import { 
  Plus,
} from 'lucide-react';
import { api } from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';
import FareList from './components/FareList';
import CreateFareStepper from './components/CreateFareStepper';
import FareConfigDetails from './FareConfigDetails';

const Fare = () => {
  const { hasPermission } = useAuth();
  const [view, setView] = useState('list'); // 'list' or 'create' or 'edit' or 'details'
  const [editingConfig, setEditingConfig] = useState(null);
  const [viewingConfig, setViewingConfig] = useState(null);

  if (!hasPermission('fare', 'view')) {
    return (
      <div className="empty-state">
        <span className="empty-state-icon text-4xl">₹</span>
        <h3 className="empty-state-title">Access Denied</h3>
        <p className="empty-state-description">
          You don't have permission to view fare configuration.
        </p>
      </div>
    );
  }

  const handleCreateNew = () => {
    setEditingConfig(null);
    setViewingConfig(null);
    setView('create');
  };

  const handleEdit = (config) => {
    setEditingConfig(config);
    setViewingConfig(null);
    setView('create');
  };

  const handleView = (config) => {
    setViewingConfig(config);
    setEditingConfig(null);
    setView('details');
  };

  const handleBackToList = () => {
    setView('list');
    setEditingConfig(null);
    setViewingConfig(null);
  };

  const handleConfigSaved = () => {
    setView('list');
    setEditingConfig(null);
    setViewingConfig(null);
  };

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="page-header">
        <div className="px-4 py-5 sm:px-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="page-title">Fare Configuration</h1>
              <p className="page-subtitle">
                Manage pricing and fare settings for different regions
              </p>
            </div>
            {hasPermission('fare', 'write') && view === 'list' && (
              <button
                onClick={handleCreateNew}
                className="btn btn-primary"
              >
                <Plus className="h-4 w-4 mr-2" />
                Create New Configuration
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Main Content */}
      {view === 'list' && (
        <FareList onEdit={handleEdit} onView={handleView} />
      )}

      {view === 'create' && (
        <CreateFareStepper
          editingConfig={editingConfig}
          onBack={handleBackToList}
          onSave={handleConfigSaved}
        />
      )}

      {view === 'details' && (
        <FareConfigDetails
          config={viewingConfig}
          onBack={handleBackToList}
          onEdit={() => handleEdit(viewingConfig)}
        />
      )}
    </div>
  );
};

export default Fare; 